<!-- @format -->
<template>
    <div class="marketing-plan-template-select-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Choose Marketing Plan</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="clientId" class="template-source">
                    <label>Source</label>
                    <source-dropdown v-model="source" :clientId="clientId" />
                </div>
                <div class="templates-container">
                    <marketing-plan-template-select-display
                        :clientId="clientId"
                        :agencyId="agencyId"
                        :multiselector="allowMultipleSelections"
                        :initialSelectedItems="initialSelectedItems"
                        @select="select"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">Cancel</app-button>
                </div>
                <div class="action-container">
                    <app-button @click="add()">Add</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const SourceDropdown = () => import('@/components/common/source-dropdown');
const MarketingPlanTemplateSelectDisplay = () =>
    import('@/components/marketing-plan/marketing-plan-template-select-display');

import EventBus from '@/scripts/event-bus.js';
import { LogLevel } from "@/scripts/logger";

export default {
    name: 'marketing-plan-template-select-widget',

    components: {
        'widget-close-svg': WidgetCloseSvg,
        'app-button': AppButton,
        'marketing-plan-template-select-display': MarketingPlanTemplateSelectDisplay,
        'source-dropdown': SourceDropdown,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            source: {
                id: 0,
                name: 'My Templates',
            },
            clientId: this.widget.clientId,
            allowMultipleSelections: this.widget.allowMultipleSelections || false,
            selectedItems: [],
            initialSelectedItems: [],
        };
    },

    computed: {
        agencyId() {
            return this.source.id || null;
        },
    },

    created() {
        if (this.widget.initialSelectedIds) {
            this.initialSelectedItems = this.widget.initialSelectedIds.map((id) => {
                return { id: id };
            });
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(items) {
            this.selectedItems = items;
        },

        add() {
            if (this.allowMultipleSelections) {
                EventBus.$emit(
                    'marketing-plan-template:select',
                    this.selectedItems.map((item) => item.id)
                );
                this.closeWidget();
            } else if (this.selectedItems.length > 0) {
                EventBus.$emit('marketing-plan-template:select', this.selectedItems[0]);
                this.closeWidget();
            } else {
                this.$helpers.showFailNotification('Please select a template to use.', { level: LogLevel.INFO });
            }
        },
    },
};
</script>

<style>
.marketing-plan-template-select-widget .action-container .save-btn {
    width: 128px;
}

.marketing-plan-template-select-widget .action-container .back-btn {
    width: 128px;
    background: transparent;
    color: #18aeff;
    margin-right: 10px;
}

.marketing-plan-template-select-widget .action-container .back-btn:hover {
    background: #e1e0e5;
}

.marketing-plan-template-select-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.marketing-plan-template-select-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.marketing-plan-template-select-widget .templates-container {
    padding: 25px 0px 0px 0px;
}
</style>
